<template>
    <div class="c-suggest">
        <div class="o-wrapper">
            <h1>Suggest a Community</h1>
            <div v-if="posted === false">
                <p>At {{ $root.brand.name }}, we are constantly adding new and exciting communities to the platform.  Should you believe there is a community that is not yet on {{ $root.brand.name }} that should be, please let us know by filling in the form below.</p>
                <p>Please keep in mind that {{ $root.brand.name }} communities must have a strong social following, especially across social networks.  The stronger this following, the more likely a community will be added to {{ $root.brand.name }}.</p>
                <form ref="suggestForm" class="u-m-t4" method="post" @submit.prevent="formSubmit">
                    <div class="c-suggest__input-group">
                        <label for="community-name">Name of Community</label>
                        <input id="community-name" v-model.trim="suggestion.communityName" ref="communityName" type="text" class="c-textbox u-width-full">
                    </div>
                    <div class="c-suggest__input-group">
                        <label for="url-w">Website URL</label>
                        <i class="icon w"></i>
                        <input id="url-w" v-model.trim="suggestion.websiteUrl" ref="websiteUrl" type="text" class="c-textbox" placeholder="https://">
                    </div>
                    <div class="c-suggest__input-group">
                        <label for="url-f">Facebook URL</label>
                        <i class="icon f"></i>
                        <input id="url-f" v-model.trim="suggestion.facebookUrl" ref="facebookUrl" type="text" class="c-textbox" placeholder="https://">
                    </div>
                    <div class="c-suggest__input-group">
                        <label for="url-t">Twitter URL</label>
                        <i class="icon t"></i>
                        <input id="url-t" v-model.trim="suggestion.twitterUrl" ref="twitterUrl" type="text" class="c-textbox" placeholder="https://">
                    </div>
                    <div class="c-suggest__input-group">
                        <label for="url-i">Instagram URL</label>
                        <i class="icon i"></i>
                        <input id="url-i" v-model.trim="suggestion.instagramUrl" ref="instagramUrl" type="text" class="c-textbox" placeholder="https://">
                    </div>
                    <div class="c-suggest__input-group">
                        <label for="url-y">YouTube URL</label>
                        <i class="icon y"></i>
                        <input id="url-y" v-model.trim="suggestion.youtubeUrl" ref="youtubeUrl" type="text" class="c-textbox" placeholder="https://">
                    </div>
                    <div class="c-suggest__input-group">
                        <label for="comments">Additional Comments</label>
                        <input id="comments" v-model.trim="suggestion.comments" ref="comments" type="text" class="c-textbox u-width-full">
                    </div>
                    <div class="c-suggest__input-group u-width-half u-width-full@l u-width-10/12@m u-width-full@s">
                        <div class="c-suggest__actions">
                            <input class="c-btn u-text-small u-p-x3 u-p-y1" type="submit" value="Submit for Review">
                        </div>
                    </div>
                </form>
            </div>
            <div v-else>
                <p>Thank you for your community suggestion - our team will review your submission and confirm whether it meets the specific criteria required to become a {{ $root.brand.name }} community.</p>
                <a v-if="previous.href" class="c-btn u-text-small u-p-x3 u-p-y1" :href="previous.href" v-html="previous.text"></a>
            </div>
            <div ref="message" :class="['c-fixed-message', 'error']">
                <p>Errors occurred!</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            suggestion: {
                communityName: null,
                websiteUrl: null,
                facebookUrl: null,
                twitterUrl: null,
                instagramUrl: null,
                youtubeUrl: null,
                comments: null
            },
            showMessage: false,
            posted: false,
            previous: {
                href: false,
                text: ''
            }
        }
    },
    mounted() {
        let previousLocation = JSON.parse(sessionStorage.getItem('previous'));
        if (previousLocation != null) {
            this.previous = {
                href: previousLocation[0],
                text: 'Go back to ' + previousLocation[1]
            }
        }
    },
    methods: {
        formSubmit() {
            if (this.validate()) {
                // only members can submit community suggestions
                if (this.$root.user === false) {
                    this.$simpleStore.showMemberPanel(this);
                    return;
                }
                let formPost = {...this.$root.user, ...this.suggestion};
                this.$http.post('/communities/suggest', formPost).then(response => {
                    this.$errorMessaging.removeErrorMessages();
                    this.posted = true;
                }, response => {
                    this.$errorMessaging.removeErrorMessages();
                });
            }
        },
        validate() {
            this.$errorMessaging.removeErrorMessages();
            let errors = [];
            let validUrl = /https?:\/\/.+\..+/;
            if (this.suggestion.communityName == null || this.suggestion.communityName.length < 3) {
                errors.push(['communityName', 'Please complete a community name with a least 3 characters']);
            }
            if (this.suggestion.websiteUrl != null && validUrl.test(this.suggestion.websiteUrl) === false) {
                errors.push(['websiteUrl', 'Please add a valid Website URL']);
            }
            if (this.suggestion.facebookUrl != null && validUrl.test(this.suggestion.facebookUrl) === false) {
                errors.push(['facebookUrl', 'Please add a valid Facebook URL']);
            }
            if (this.suggestion.twitterUrl != null && validUrl.test(this.suggestion.twitterUrl) === false) {
                errors.push(['twitterUrl', 'Please add a valid Twitter URL']);
            }
            if (this.suggestion.instagramUrl != null && validUrl.test(this.suggestion.instagramUrl) === false) {
                errors.push(['instagramUrl', 'Please add a valid Instagram URL']);
            }
            if (this.suggestion.youtubeUrl != null && validUrl.test(this.suggestion.youtubeUrl) === false) {
                errors.push(['youtubeUrl', 'Please add a valid YouTube URL']);
            }
            /*if (this.suggestion.facebookUrl == null && this.suggestion.twitterUrl == null && this.suggestion.instagramUrl == null && this.suggestion.youtubeUrl == null) {
            errors.push(['facebookUrl', 'Please complete at least social network URL for this community']);
            }*/
            if (errors.length > 0) {
                for (let i = 0; i < errors.length; i++) {
                    let field = errors[i][0];
                    let errorMessage = errors[i][1];
                    this.$errorMessaging.showFieldError(this.$refs, field, errorMessage);
                }
                this.$errorMessaging.showGlobalError(this.$refs, 'message');
                return false
            }
            return true;
        }
    }
}
</script>
